import { Controller } from 'stimulus';
export default class extends Controller {
  static targets = ['modalitySelect', 'childSelect', 'devices'];
  
  fetchModality() {
    this.selectChangeUrl= document.location.origin + `/modalities/${this.modalitySelectTarget.value}/certification_request_child_modalities.json`;
        
    const study_id = this.data.get('study');
    const childModalityId = this.data.get('childModalityId');
    const deviceId = this.data.get('deviceId');
    fetch(this.selectChangeUrl, {
      headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'X-CSRF-Token': document.head.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({ study_id: study_id }),
      method: 'POST',
    })
    .then(response => response.json())
    .then((data) => {
      const selectBox = this.childSelectTarget;
      const deviceSelectBox = this.devicesTarget;

      // Enable & reset selects
      selectBox.disabled = false;
      selectBox.innerHTML = '';
      deviceSelectBox.innerHTML = '';

      // ----- Child Modality default option -----
      const childDefaultOption = document.createElement('option');
      childDefaultOption.value = "";
      childDefaultOption.innerHTML = "Select Child Modality";
      childDefaultOption.selected = childModalityId === "";
      selectBox.appendChild(childDefaultOption);

      // Child Modalities
      data["child_modalities"].forEach((item) => {
        const opt = document.createElement('option');
        opt.value = item[0];
        opt.innerHTML = item[1];
        opt.selected = childModalityId === item[0];
        selectBox.appendChild(opt);
      });

      // ----- Device default option -----
      const deviceDefaultOption = document.createElement('option');
      deviceDefaultOption.value = "";
      deviceDefaultOption.innerHTML = "Select Device";
      deviceDefaultOption.selected = true;
      deviceSelectBox.appendChild(deviceDefaultOption);
    });
  }

  childModalitySelectCheck(initialize = false) {
    this.selectChangeUrl = document.location.origin + `/modalities/${this.modalitySelectTarget.value}/get_certification_request_specific_devices.json`;
    const childModalityId = this.childSelectTarget.value; 
    const study_id = this.data.get('study');
    // populate child modalities
    fetch(this.selectChangeUrl, {
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'X-CSRF-Token': document.head.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({ study_id: study_id, child_modality_id: childModalityId }),
        method: 'POST',
    })
    .then(response => response.json())
    .then((data) => {
      
        const deviceselectBox = this.devicesTarget;
        deviceselectBox.disabled = false;
        deviceselectBox.innerHTML = '';
        // default text
        const devicesdefaultOption = document.createElement('option');
        devicesdefaultOption.value = "";
        devicesdefaultOption.innerHTML = "Select Device";
        devicesdefaultOption.selected === "";
        deviceselectBox.appendChild(devicesdefaultOption);
        // loop through data
        data["devices"].forEach((item, index) => {
            const opt = document.createElement('option');
            opt.value = item["id"];
            opt.innerHTML = item["name"];
            opt.selected === item["id"];
            deviceselectBox.appendChild(opt);
        }); 
    });
  }
}
